/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Collection_HeadingInputs */

const en_home_collection_heading = /** @type {(inputs: Home_Collection_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore the Collection`)
};

/**
* | output |
* | --- |
* | "Explore the Collection" |
*
* @param {Home_Collection_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_collection_heading = /** @type {((inputs?: Home_Collection_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Collection_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_collection_heading(inputs)
});